// extracted by mini-css-extract-plugin
export default {"userIcon":"PersonalDetailsForm_userIcon__+n4qM","userImageLabel":"PersonalDetailsForm_userImageLabel__oSecF"};